const DEFAULT_RELOAD_INTERVAL_MS = 10000

/**
 * Starts a repeating callback and always clears it when the view is left.
 *
 * Tab switches destroy the route component (no keep-alive). `deactivated`
 * covers keep-alive if it is added later.
 */
export default {
    data () {
        return {
            reloadTimerId: null,
            reloadStopped: false
        }
    },
    methods: {
        startReloadInterval (callback, intervalMs = DEFAULT_RELOAD_INTERVAL_MS) {
            this.stopReloadInterval()
            this.reloadStopped = false
            this.reloadTimerCallback = callback
            this.reloadTimerId = setInterval(() => {
                if (this.reloadStopped || typeof this.reloadTimerCallback !== 'function') {
                    return
                }
                this.reloadTimerCallback()
            }, intervalMs)
        },
        stopReloadInterval () {
            this.reloadStopped = true
            this.reloadTimerCallback = null
            if (this.reloadTimerId != null) {
                clearInterval(this.reloadTimerId)
                this.reloadTimerId = null
            }
        }
    },
    deactivated () {
        this.stopReloadInterval()
    },
    beforeUnmount () {
        this.stopReloadInterval()
    }
}
